import i18n from "@/i18ns/i18n.js";
import guardRoute from "@/commons/authGuard";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "MainLayout" */ "@/views/Account/index.vue"),
    beforeEnter: (to, from, next) => {
      guardRoute(to, from, next, "Login", "View");
    },
    // children: [
    //   {
    //     path: "user",
    //     name: "user",
    //     component: () =>
    //       import(
    //         "@/views/Setting/User/SettingUser.vue"
    //       ),
    //     meta: {
    //       Title: "Người dùng",
    //     },
    //     beforeEnter: (to, from, next) => {
    //       guardRoute(to, from, next, "User", "View");
    //     },
    //   },
    //   {
    //     path: "user-group",

    //     component: () =>
    //       import(
    //         "@/views/Setting/SettingUserGroup/SettingUserGroup.vue"
    //       ),
    //     meta: {
    //       Title: "Nhóm người dùng",
    //     },
    //     beforeEnter: (to, from, next) => {
    //       guardRoute(to, from, next, "UserGroup", "View");
    //     },
    //   },

    // ],
    meta: {
      Title: "đăng nhập",
    },
  },
  {
    path: "/change-password",
    component: () =>
      import(/* webpackChunkName: "MainLayout" */ "@/views/Account/index.vue"),
    meta: {
      Title: "Đổi mật khẩu",
    },
  },
];

export default routes;
